export enum IkeQuerySort {
	ASC = 1,
	DES = -1,
}
